module.exports = __webpack_public_path__ + "static/media/brand_visa.6b904cdc.svg";